import { useEffect } from 'react';
import confetti from 'canvas-confetti';

export default function FireworksLayer({ onFinish }: { onFinish?: () => void }) {
    useEffect(() => {
        fireConfetti();

        const timer = setTimeout(() => {
            if (onFinish) {
                onFinish();
            }
        }, 3000);

        return () => clearTimeout(timer);
    }, []);

    const fireConfetti = () => {
        confetti({
            particleCount: 200, // 입자 200개
            spread: 90, // 퍼지는 각도
            startVelocity: 40, // 터질 때 속도
            origin: { y: 0.6 } // 화면 어느 높이에서 터질지
        });
    };

    return null; // 화면에 아무것도 안 보임
}
